/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Dialog,
  DialogBody,
  DialogIcon,
  DialogText,
  ContentTextarea,
  DialogCancel,
  DialogConfirm,
} from './styles';
import DragZoneUpload from 'components/DragZoneUpload';
import TagsList3 from "components/TagList3";
import { Col } from 'components/Grid';

export default function ModalMASConfirmation({ idOperation, changeAttachmentFiles, show, onConfirm, onCancel, title = '' }) {
  const [files, setFiles] = useState([])
  const [hasUpload, setHasUpload] = useState(false);
  const myRef = useRef();

  const handleConfirm = () => {
    onConfirm()
  }

  const removeAttachment = item => {
    let elementToRemove, newAttachments;

    elementToRemove = files.find((att, index) => index === item);
    newAttachments = files.filter(attachment => attachment.documentId !== elementToRemove.documentId);
    setFiles(newAttachments);
    changeAttachmentFiles(newAttachments);
    setHasUpload(!hasUpload);
  }

  return (
    <Dialog canShow={show} >
      <DialogBody ref={myRef}>
        <DialogIcon pink={'exclamation'}>
          <FontAwesomeIcon icon={['fas', 'exclamation']}></FontAwesomeIcon>
          <DialogText>{title || 'MAS Compliance'}</DialogText>
        </DialogIcon>
        <ContentTextarea>
          <p> 
            By clicking CONFIRM you are confirming that you have obtained all the approvals from the required regulators and attached them in the below box.
            Failure to do so, is a breach of our policies and obligations and might result in penalty to the company.
          </p>
          <br/>
          <div>
            <DragZoneUpload
              idOperation={idOperation}
              autoUpload={true}
              multiple={false}
              documentType={{dsAnswerOption: "Internal Documents"}}
              isInternalDocument
              height="30"
              isDraft={false}
              onSuccess={(uploadedFiles) => {
                setFiles([...files, ...uploadedFiles]);
                changeAttachmentFiles([...files, ...uploadedFiles])
                setHasUpload(true)
              }}/>

              {(hasUpload && files) && (
                <div style={{width: '100%'}}>
                  <Col md={12} sm={12}>
                    <TagsList3
                      small
                      tags={files.filter(file => file.fileName).map(file => ({ ...file, dsTypeDocument: file?.documentType?.dsAnswerOption, urlLink: file.fileUrl }))}
                      disableType
                      hideTrash={false}
                      removeTag={(index) => removeAttachment(index)}
                    />
                  </Col>
                </div>
              )}
          </div>
          <div style={{marginTop: '15px'}}>
            <DialogCancel onClick={() => {onCancel && onCancel(); }}>CANCEL</DialogCancel>
            <DialogConfirm onClick={() => handleConfirm()} disabled={!hasUpload}>CONFIRM</DialogConfirm>
          </div>
        </ContentTextarea>
      </DialogBody>
    </Dialog>

  );
}